<template>
  <form class="mt-2" id="form-modal">
    <!-- title input -->
    <div class="form-group">
      <label class="label-form">Title<span style="color: red">*</span>:</label>
      <input type="text" class="form-control" v-model="categoryForm.title" />
    </div>

    <!-- description input -->
    <div class="form-group">
      <label class="label-form"
        >Description<span style="color: red">*</span>:</label
      >
      <textarea
        class="form-control"
        v-model="categoryForm.description"
      ></textarea>
    </div>

    <!-- parent input -->
    <div class="form-group">
      <label class="label-form">Parent Category:</label>
      <multiselect
        :options="selectedCategories"
        @open="getAllPost"
        :internal-search="false"
        :allow-empty="true"
        :options-limit="20"
        :selectedLabel="null"
        :deselectLabel="null"
        :selectLabel="null"
        :max-height="130"
        @search-change="searchCategories"
        placeholder="select the parent category"
        v-model="categoryForm.parent_category"
        label="title"
        track-by="id"
      >
      </multiselect>
    </div>
    <div class="form-group">
      <label class="label-form" for="slug"
        >slug<span style="color: red">*</span>:</label
      >
      <input
        type="text"
        class="form-control"
        id="slug"
        v-model="categoryForm.new_slug"
      />
    </div>
    <div class="form-group">
      <label class="label-form" for="meta_title">Meta Title:</label>
      <input
        type="text"
        class="form-control"
        v-model="categoryForm.meta_title"
      />
    </div>
    <div class="form-group">
      <label class="label-form" for="meta_description">Meta Description:</label>
      <input
        type="text"
        class="form-control"
        v-model="categoryForm.meta_description"
      />
    </div>
    <div class="form-group">
      <label class="label-form" for="meta_keyword">Meta keyword:</label>
      <input
        type="text"
        class="form-control"
        v-model="categoryForm.meta_keyword"
      />
    </div>
    <div class="form-group" style="position: relative">
      <label class="label-form">Icon:</label>
      <vfa-picker v-model="categoryForm.icon">
        <template v-slot:activator="{ on }">
          <input
            v-model="categoryForm.icon"
            @click="on"
            placeholder="Icon Class"
            class="form-control"
            type="text"
            readonly
          />
        </template>
      </vfa-picker>
      <span
        v-if="categoryForm.icon"
        @click="unsetIcon"
        class="clear-icon"
        style="
          position: absolute;
          right: 10px;
          top: 70%;
          transform: translateY(-50%);
          cursor: pointer;
          color: red;
        "
      >
        &times;
      </span>
    </div>
    <div class="text-right">
      <button
        type="button"
        class="btn btn-secondary"
        data-dismiss="modal"
        @click="close"
      >
        Close
      </button>
      <button type="button" class="btn btn-default ml-1" @click="save">
        <font-awesome-icon
          v-if="mini_loading"
          icon="spinner"
          style="
            animation: spin 2s linear infinite;
            float: right;
            margin-left: 5px;
            margin-top: 3px;
          "
        />
        {{ action !== "update" ? "Save" : "Update" }}
      </button>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import VueFontAwesomePicker from "vfa-picker";

Vue.use(VueFontAwesomePicker);

export default {
  components: {
    Multiselect,
  },

  props: ["action", "formData"],

  data: function () {
    return {
      selectedCategories: [],
      productId: localStorage.getItem("product_id"),
      mini_loading: false,
      categoryForm: {
        icon: undefined,
      },
      parent_category_old_value: {},
      // softwareOptions: {},
    };
  },

  computed: {
    product: function () {
      return this.$store.getters["posts/product"];
    },
    softwareOptions: function () {
      return this.$store.getters["persist/availableProducts"];
    },
    categories: function () {
      return this.$store.getters["categories/search"];
    },
    users: function () {
      return this.$store.getters["users/usersSearch"];
    },
  },
  watch: {
    productId(newValue, oldValue) {
      if (this.action === "create") {
        this.categoryForm.parent_category.title = "";
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  created: function () {
    this.startPolling();
    if (this.action === "update") {
      this.categoryForm = JSON.parse(JSON.stringify(this.formData));

      //  this.categoryForm.parent_category  = this.product.filter(category =>
      //   category.title === this.formData.parent_category.title
      // );
      this.categoryForm.new_slug = JSON.parse(
        JSON.stringify(this.formData.slug.split("-").join(" "))
      );
    }
  },

  methods: {
    unsetIcon() {
      this.categoryForm.icon = undefined;
    },
    getAllPost() {
      this.$store.dispatch("posts/getProduct").then((response) => {
        if (this.action === "update") {
          // Editing case: Filter out the category being edited
          this.selectedCategories = response.filter(
            (category) => category.title !== this.formData.title
          );
        } else {
          // Creating case: Show all categories
          this.selectedCategories = response;
        }
      });
    },
    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.productId = localStorage.getItem("product");
      }, 1000);
    },
    stopPolling() {
      clearInterval(this.pollingInterval);
    },
    searchCategories(query) {
      if (this.product && query) {
        this.selectedCategories = this.product.filter((category) =>
          category.title.toLowerCase().includes(query.toLowerCase())
        );

        if (this.action === "update") {
          this.selectedCategories = this.selectedCategories.filter(
            (category) => category.title !== this.formData.title
          );
        }
      } else if (this.action === "update") {
        // Editing case: No search query, but filter out the category being edited
        this.selectedCategories = this.product.filter(
          (category) => category.title !== this.formData.title
        );
      } else {
        // If no search query, show all products
        this.selectedCategories = this.product;
      }
    },

    searchUsers(query) {
      window._.debounce(async function (vm, query) {
        if (query != "") {
          await vm.$store.dispatch("users/searchUsers", query);
        }
      }, 300)(this, query);
    },
    close() {
      if (this.action == "create") {
        this.categoryForm = [];
      }
    },
    save() {
      if (
        this.categoryForm.title == "" ||
        this.categoryForm.title == undefined ||
        this.categoryForm.description == "" ||
        this.categoryForm.description == undefined ||
        this.categoryForm.new_slug == "" ||
        this.categoryForm.new_slug == undefined
      ) {
        if (
          this.categoryForm.new_slug == "" ||
          this.categoryForm.new_slug == undefined
        ) {
          this.$toast.error(`Slug field is required.`);
        }
        if (
          this.categoryForm.description == "" ||
          this.categoryForm.description == undefined
        ) {
          this.$toast.error("The description field is required");
        }
        if (
          this.categoryForm.title == "" ||
          this.categoryForm.title == undefined
        ) {
          this.$toast.error("The title field is required");
        }
        return false;
      } else {
        if (this.action == "create") {
          this.create(this.categoryForm);
        } else if (this.action == "update") {
          this.update(this.categoryForm);
        }
      }
    },

    async create(category) {
      try {
        this.mini_loading = true;
        let self = this;
        await this.$store.dispatch("categories/createCategory", category);

        self.categoryForm = {};
        this.mini_loading = false;
        this.$toast.success(
          `${category.title} category has been added successfully`
        );

        window.$("#modal").modal("hide");
        await this.$store.dispatch("categories/getAllCategories", 1);
      } catch (error) {
        this.mini_loading = false;
        let response = error.response;

        if (response && response.status === 422) {
          let errors = response.data.errors;

          if (errors) {
            if (errors.slug) {
              this.$toast.error(errors.slug[0]); // Show the first error related to slug
            }
            if (errors.title) {
              this.$toast.error(errors.title[0]); // Show the first error related to title
            }
            if (errors.description) {
              this.$toast.error(errors.description[0]); // Show the first error related to title
            }
          }
        } else {
          this.$toast.error("An unexpected error occurred.");
        }
      }
    },

    update(category) {
      this.mini_loading = true;
      this.$store
        .dispatch("categories/updateCategory", category)
        .then(() => {
          this.mini_loading = false;
          this.$toast.success(
            `${category.title} category has been updated successfully`
          );
          window.$("#modal").modal("hide");
        })
        .catch((error) => {
          this.mini_loading = false;
          let response = error.response;

          if (response && response.status === 422) {
            // 422 is the validation error code
            let errors = response.data.errors;

            if (errors) {
              if (errors.slug) {
                this.$toast.error(errors.slug[0]); // Show the first error related to slug
              }
              if (errors.title) {
                this.$toast.error(errors.title[0]); // Show the first error related to title
              }
              // Optionally, handle other errors
              if (response.data.message) {
                this.$toast.error(response.data.message); // Show a generic error message if present
              }
            }
          } else {
            this.$toast.error("An unexpected error occurred."); // Handle non-validation errors
          }
        });
    },
  },
};
</script>
